import { render, staticRenderFns } from "./HomeCard.vue?vue&type=template&id=4884e5a9&scoped=true"
import script from "./HomeCard.vue?vue&type=script&lang=js"
export * from "./HomeCard.vue?vue&type=script&lang=js"
import style0 from "./HomeCard.vue?vue&type=style&index=0&id=4884e5a9&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4884e5a9",
  null
  
)

export default component.exports